import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/teams`)
  return data.data
}

export const useTeams = () => {
  const { data, ...props } = useQuery(
    queryKeys.TEAMS,
    () => getData(),
  )
  return { data, ...props }
}
